import React from 'react';
import {TextField} from '@material-ui/core';
import {useForm} from 'react-hook-form';

interface Props {
  onChange: (val: number) => void;
}

const PaginationNumber: FC<Props> = ({onChange}: Props): React.ReactElement => {
  const {register, handleSubmit, reset} = useForm();

  const submitPage = ({page}: {page: number}) => {
    if(page - 1 >= 0) {
      onChange(page -1)
      reset({number: ''})
    }
  }
  return (
    <div style={{maxWidth: '120px'}}>
      <form onSubmit={handleSubmit(submitPage)}>
        <TextField
          type='number'
          inputRef={register}
          placeholder='عدد صفحه'
          name='page'
          fullWidth
         />
      </form>
    </div>
  );
};

export default PaginationNumber;
